export default __webpack_public_path__ + "navigation-guides-turn-by-turn-ui-speed-limit-960-d5cb61ca2380e84dc03a57621765300a.webp";